import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import Tooltip from 'apollo-react/components/Tooltip';
import Download from 'apollo-react-icons/Download';
import Export from 'apollo-react-icons/Export';
import React from 'react';
import { useDispatch } from 'react-redux';

import { handleErrors } from '../../../../../actions/ErrorActions';
import { useTranslation } from '../../../../../custom-hooks/useTranslation';
import { parseLegacyURL } from '../../../../../utils/legacyRouteMapper';
import { downloadLogFile } from '../../../../actions/import.actions';
import {
  COMPARISON_DELTA_LINK,
  COMPARISON_DESIGNER_LINK,
  STATUS_ACCESSOR,
  TYPE_ACCESSOR,
} from '../../../../constants/common.constants';
import {
  FORM_TYPE,
  STATUSES,
  TYPES_TO_ALLOW_ACTIONS,
  WORKFLOW_LOG_FILE_NAME,
  WORKFLOW_TYPE,
} from '../../../../constants/import.constants';

const useStyles = makeStyles({
  cell: {
    display: 'flex',
    justifyContent: 'end',
  },
});

const ActionsCell = ({ row }) => {
  const translateString = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { zipFieldId } = row;

  const type = row[TYPE_ACCESSOR];
  const link = row[COMPARISON_DESIGNER_LINK];
  const deltaChangesLink = row[COMPARISON_DELTA_LINK];
  const statusCode = row[STATUS_ACCESSOR];

  const handleOpen = () => {
    try {
      const { url } = parseLegacyURL(link?.replace('../', ''));
      window.open(url, '_blank');
    } catch (e) {
      dispatch(handleErrors([{ errorMessage: e, errorNumber: '' }]));
    }
  };

  const handleDownload = () => {
    if (type === FORM_TYPE) {
      const { url } = parseLegacyURL(deltaChangesLink?.replace('../', ''));
      window.open(url);
    } else if (type === WORKFLOW_TYPE) {
      dispatch(downloadLogFile({ importKey: zipFieldId, fileName: WORKFLOW_LOG_FILE_NAME }));
    }
  };

  const isActionsAvailable =
    TYPES_TO_ALLOW_ACTIONS.includes(type) && statusCode !== STATUSES.CANCEL;

  return (
    <>
      {isActionsAvailable && (
        <div className={classes.cell}>
          <Tooltip
            title={translateString('Open in designer')}
            placement="left-end"
            disableFocusListener
          >
            <IconButton size="medium" onClick={() => handleOpen()}>
              <Export />
            </IconButton>
          </Tooltip>

          <Tooltip
            title={translateString('Download delta changes')}
            placement="left-end"
            disableFocusListener
          >
            <IconButton size="medium" onClick={handleDownload}>
              <Download />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </>
  );
};

export default ActionsCell;
